//import { Rating } from 'primereact/rating';
import { Rating } from 'react-simple-star-rating'
import React, { useCallback, useRef, useState } from 'react';
import { FormSectionElements, ProgramContainer } from '../../entities/formTemplateDataType';
import { Card } from 'primereact/card';
import { getRootComponent } from '../../utilities/ElementUtils';

export type StarRatingProps = {
    field: FormSectionElements;
    title;
    isEng: boolean;
    callbackElement: (ProgramContainer) => void;
}

const StarRating = ({field, title, isEng, callbackElement }: StarRatingProps) => {
    const [rating, setRating] = useState(0);

    const tooltips = {
        en: [
            "Terrible",
            "Bad",
            "Average",
            "Great",
            "Awesome",
        ],
        fr: [
            "Terrible",
            "Mauvais",
            "Moyenne",
            "Super",
            "Génial",
        ],
    }

    const handleRating = (value: number) => {
        setRating(value);
        field.Value = value;
        callbackElement(getRootComponent(field));
    }

    const ratingRef = useCallback((node) => {
        if (!node) return;

        const ratingNode = node.querySelector('span.react-simple-star-rating-tooltip');
        if (ratingNode) {
            const value = ratingNode.innerHTML;
            const lang = isEng ? 'en' : 'fr';
            if (!tooltips[lang].includes(value)) {
                ratingNode.innerHTML = isEng? 'Your Rating' : 'Votre note';
            }
        }
    }, [isEng]);

    return (
        <div className="ontario-margin-top-24-! ontario-margin-bottom-32-!">
            {/* @ts-ignore */}
            <Card title={title || isEng ? 'Please rate the quiz' : 'Veuillez évaluer le quiz'} ref={ratingRef}>
                {/* @ts-ignore */}
                <Rating
                    onClick={handleRating}
                    initialValue={rating}
                    showTooltip
                    tooltipArray={isEng ? tooltips.en : tooltips.fr}
                />
            </Card>
        </div>
    )

}

export default StarRating;